import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row Types ───

export interface OdontogramChartRow {
  id: string;
  org_id: string;
  clinic_id: string | null;
  patient_id: string;
  encounter_id: string | null;
  visit_id: string | null;
  chart_type: string;
  status: string; // 'draft' | 'final'
  source: string;
  notes: string | null;
  tooth_states: string | null; // JSON string
  created_by_user_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

// ─── Queries ───

/**
 * All charts for a specific encounter, newest first.
 */
export function qOdontogramChartsByEncounter(encounterId: string): QuerySpec<[string]> {
  return {
    key: ['odontogram_charts', 'by-encounter', encounterId] as const,
    sql: `SELECT * FROM odontogram_charts WHERE encounter_id = ? ORDER BY created_at DESC`,
    params: [encounterId],
    watch: ['odontogram_charts'],
  };
}

/**
 * All charts for a patient (for chart selector / history), newest first.
 */
export function qOdontogramChartsByPatient(patientId: string): QuerySpec<[string]> {
  return {
    key: ['odontogram_charts', 'by-patient', patientId] as const,
    sql: `SELECT * FROM odontogram_charts WHERE patient_id = ? ORDER BY created_at DESC`,
    params: [patientId],
    watch: ['odontogram_charts'],
  };
}

/**
 * Single chart by ID.
 */
export function qOdontogramChartById(chartId: string): QuerySpec<[string]> {
  return {
    key: ['odontogram_charts', 'by-id', chartId] as const,
    sql: `SELECT * FROM odontogram_charts WHERE id = ?`,
    params: [chartId],
    watch: ['odontogram_charts'],
  };
}
